import { HStack, Text, Box, Icon, Button } from '@chakra-ui/react';
import { AiOutlineMenu } from 'react-icons/ai';
import { useNavigate, useParams } from 'react-router-dom';
import { Logo } from '~/icons';
import getPath from '~/utils/getNavigatePath';

export type HeaderProps = {
  onOpen: () => void;
};

export default function Header({ onOpen }: HeaderProps) {
  const navigate = useNavigate();
  const { groupId = '', enterpriseGroupBuyId = '' } = useParams();

  return (
    <HStack justify="space-between" w="full" h="50px" align="center">
      <Box w="5rem">
        <Icon
          as={AiOutlineMenu}
          display={{ base: 'block', md: 'none' }}
          boxSize="1.5rem"
          cursor="pointer"
          onClick={onOpen}
        />
      </Box>

      <HStack
        align="center"
        justify="center"
        flex={1}
        onClick={() => navigate(getPath('/', groupId, enterpriseGroupBuyId))}
        as="button"
      >
        <Icon as={Logo} boxSize="1.5rem" />
        <Text>蔬氧-VO2</Text>
      </HStack>

      {!!enterpriseGroupBuyId ? (
        <Box w="5rem" />
      ) : (
        <Button
          w="5rem"
          size="sm"
          color="primary"
          bgColor="#FFF8ED"
          onClick={() => navigate(groupId ? `/group/${groupId}/groupBuy` : '/groupBuy')}
        >
          {groupId ? '開團中' : '我要開團'}
        </Button>
      )}
    </HStack>
  );
}
